<button
  [ngClass]="iconColor"
  [attr.data-popover-target]="popoverTargetId"
  data-popover-placement="bottom-end"
  type="button"
  appAgentAction
  agent="help-popover-toggle"
  action="toggle"
>
  <app-info-icon></app-info-icon>
  <span class="sr-only">Show information</span>
</button>
<div
  data-popover
  [id]="popoverTargetId"
  role="tooltip"
  class="absolute z-10 invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-md opacity-0 w-96"
>
  <div class="p-3 space-y-2">
    <h3 class="font-bold text-gray-900">{{ getTitle() }}</h3>
    @for (paragraph of paragraphs; track $index) {
      <h3 [innerHTML]="paragraph.header" class="font-semibold text-gray-800"></h3>
      <div [innerHTML]="paragraph.content"></div>
    }
  </div>
  <div data-popper-arrow></div>
</div>
